import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { languageProgramsManagement } from "../../../../../../hooks/api/LanguageProgramsManagement";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { languagesManagement } from "../../../../../../hooks/api/LanguagesManagement";
import { prepareSelect } from "../../../../../../services/core/Select";
import { Select } from "../../../../../../themes/Default/components/Form/components/Select";
import Divider from "../../../../../../themes/Default/components/Divider/Divider";

const EditProgram = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const { programId } = useParams();
    const [formErrors, setFormErrors] = useState([]);
    const { useUpdateProgramMutation, useViewProgramMutation} = languageProgramsManagement;
    const [updateProgram, {isLoading: isUpdateingProgram}] = useUpdateProgramMutation();
    const [viewProgram] = useViewProgramMutation();
    const { useLanguageListMutation } = languagesManagement;
    const [languagesList] = useLanguageListMutation();
    const [languages, setLanguages] = useState([]);

    const tabs = [
        { title: t('languages.title'), onClick: () => gotoLanguagesTab() },
        { title: t('program.title'), isActive: true },
    ];

    const gotoLanguagesTab = () => {
        navigate("/settings/languages/languages");
    }

    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        const body = {...values};
        updateProgram({body, programId}).then((result) => {
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/programs/programs");
                toast.info(result?.data?.info?.responseMessage);
            }
        });
    };

    useEffect(() => {
        viewProgram(programId).then((result) => {
            formRef.current.setValues(result?.data);
            console.log(result?.data);
        });

    }, []);

    useEffect(() => {
                languagesList({}).then((result) => {
                        let options = [];
                        result?.data?.records.map((language) => {
                            options.push({
                                id: language.id,
                                name: language.name,
                            });
                        });
                        setLanguages(prepareSelect(options));
                    });
            }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/programs/programs" />
                <Button title={t('save')} isDisabled={isUpdateingProgram} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
            <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("languages.title")} />
                    <Link title={t("program.title")} />
                    <Link title={t("program.addProgram")} isActive={true} />
                </Breadcrumps>
                    <Formik
                        innerRef={formRef}
                        initialValues={{
                            name: "",
                            language: "",
                            book: "",
                            notebook: ""
                        }}
                        onSubmit={onSaved}
                    >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("languages.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>   
                                <Field>
                                    <Select
                                        name="language"
                                        label={t("program.language")}
                                        required={true}
                                        options={languages}
                                        onChange={handleChange}
                                        selectedValue={values.language}
                                        error={formErrors?.language}
                                    />
                                </Field>                             
                            </Row>
                            {/* <Divider title={t("additionalInformation")} />
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input
                                        name="book"
                                        label={t("program.book")}
                                        value={values.book}
                                        onChange={handleChange}
                                        error={formErrors?.book}
                                    />
                                </Field>                               
                            </Row>
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input
                                        name="notebook"
                                        label={t("program.notebook")}
                                        value={values.notebook}
                                        onChange={handleChange}
                                        error={formErrors?.notebook}
                                    />
                                </Field>                               
                            </Row> */}
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default EditProgram;